interface Props {
  /** Label rendered above the swatches. Pass an empty string to hide it. */
  label?: string;
  value: string;
  onChange: (color: string) => void;
}

/** The three theme colors a voucher can be assigned. */
export const VOUCHER_SWATCH_COLORS = ["#176170", "#735D9B", "#FF5726"];

export const ColorSwatchPicker = ({
  label = "Color",
  value,
  onChange,
}: Props) => {
  return (
    <div>
      {label ? (
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {label}
        </label>
      ) : null}
      <div className="flex flex-row items-center gap-3">
        {VOUCHER_SWATCH_COLORS.map((swatch) => {
          const isSelected =
            swatch.toLowerCase() === (value || "").toLowerCase();
          return (
            <button
              key={swatch}
              type="button"
              aria-label={`Select color ${swatch}`}
              onClick={() => onChange(swatch)}
              style={{ backgroundColor: swatch }}
              className={`w-8 h-8 rounded-full transition-all focus:outline-none ${
                isSelected
                  ? "ring-2 ring-offset-2 ring-dark"
                  : "ring-1 ring-gray-border"
              }`}
            />
          );
        })}
      </div>
    </div>
  );
};
